<template>
  <div>
    <player-enforce-state
      :playerId="playerId"
      class="mb-4"
    />

    <b-card
      header="Permanent player deletion"
      bg-variant="light"
    >
      <b-button @click="submitRemoved" variant="danger">Delete all data</b-button>
    </b-card>

    <b-card
      header="Club"
      bg-variant="light"
    >
      <b-button @click="deleteFromAnyClub" variant="danger">Delete from any club</b-button>
    </b-card>

  </div>
</template>

<script>
import { HTTP } from '../http-common.js';
import notifier from '../notifier.js';
import PlayerEnforceState from './PlayerEnforceState.vue';

export default {
  components: {
    PlayerEnforceState,
  },

  props: {
    playerId: {
      type: Number,
      required: true
    }
  },

  methods : {
    submitRemoved() {
      var app = this 
      this.$dialog
      .confirm('Are you sure you want to remove this player? This operation can not be undone.')
        .then(function() {
          let data = new FormData();
          HTTP.post("/player/" + app.playerId + "/remove_all", data)
          .then(() => {
            notifier.showSuccessAfterTransition("Player was removed");
            app.$router.push({name: 'player_find'});
          })
          .catch(e => {
            notifier.showError(e.response.data, {sender: app});
          })
        })
      .catch(function() {
        //on cancel
      });
    },

    deleteFromAnyClub() {
      notifier.deleteSenderNotifications(this);

      const url = `/player/${this.playerId}/delete_from_any_club`;
      HTTP.post(url)
      .then(() => {
        notifier.showSuccess('Done.');
      })
      .catch(err => {
        notifier.showError(err, {sender: this});
      });
    },
  }
}
</script>

<style scoped>
.card {
  margin-bottom: 2em;
}
</style>
